import React from "react";
import ReactDOM from "react-dom";
import EmbedGridDetailBase from "./EmbedGridDetailBase";
import { applyOztixUtm } from "../../../helper/oztixHelper";
import "./EmbedGigGridDetails.css";
import { ProfileType } from "../../../types/enum";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const blankBackground = "/hero2.jpg";

class EmbedGigGridDetails extends EmbedGridDetailBase {
    state = {
        clicked: false,
        bioExpanded: false,
        region: null,
    };

    render() {
        const { data, profile, open, tableFtColor, tableWidgetBgColor, actGenreString } = this.props;
        const { bioExpanded } = this.state;

        if (!open || !data) return null;

        var bookingUrl = data?.bookTableUrl?.includes("https://") ? data?.bookTableUrl : "https://" + data?.bookTableUrl;
        var ticketUrl = applyOztixUtm(data?.ticketUrl?.includes("https://") ? data?.ticketUrl : "https://" + data?.ticketUrl);

        const imageUrl = profile?.type === ProfileType.Musician.ordinal
            ? data?.venueCover
            : (data?.profileImageCover || blankBackground);
        const displayName = profile?.type === ProfileType.Musician.ordinal ? data?.venueName : data?.actName;
        const profileId = data?.actId;

        const fullBio = profile?.type === ProfileType.Musician.ordinal ? data?.venueBio : data?.actBio;
        const shortBio = profile?.type === ProfileType.Musician.ordinal ? data?.shortVenueBio : data?.shortActBio;
        const isTruncated = fullBio && shortBio && fullBio !== shortBio;

        const overlayStyle = this.getOverlayStyle();

        const portalTarget = this.portalTarget;

        const modal = (
            <div className="embed-detail-overlay" style={overlayStyle}>
                {/* Backdrop */}
                <div
                    data-embed-backdrop
                    onClick={this.handleClose}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.55)",
                    }}
                />

                {/* Card */}
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-label={displayName || "Event details"}
                    className="embed-detail-card"
                    style={{
                        position: "relative",
                        background: "#fff",
                        borderRadius: 16,
                        boxShadow: "0 8px 40px rgba(0,0,0,0.28)",
                        width: "min(820px, 92vw)",
                        maxHeight: "calc(100% - 24px)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "row",
                        padding: 12,
                    }}
                >
                    <button className="embed-detail-close" onClick={this.handleClose} aria-label="Close">×</button>

                    <div
                        style={{
                            position: "relative",
                            width: "48%",
                            flexShrink: 0,
                            borderRadius: 12,
                            overflow: "hidden",
                            backgroundColor: tableWidgetBgColor
                        }}
                    >
                        <img
                            src={imageUrl}
                            alt={displayName || "Gig"}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "top center",
                                display: "block",
                                borderRadius: 12
                            }}
                            onError={e => { e.target.src = blankBackground; }}
                        />
                        <div style={{ position: "absolute", bottom: 0, left: 0, width: "100%", height: "60%", background: "linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 100%)" }} />
                        <div className="topcorner" style={{ backgroundColor: tableWidgetBgColor }}>
                            <div style={{ fontSize: "19px", fontFamily: "Raleway", fontWeight: "bold", color: tableFtColor }}>{`${data?.day?.toUpperCase()} ${data?.date}`}</div>
                            <div style={{ fontSize: "15px", fontFamily: "Raleway", fontWeight: "bold", color: tableFtColor }}>{data?.month}</div>
                            <div style={{ fontSize: "11px", fontFamily: "Raleway", fontWeight: "bold", color: tableFtColor }}>{data?.startTimeString}</div>
                        </div>
                    </div>

                    <div className="embed-detail-scroll" ref={el => { this.scrollContent = el; }} style={{ width: "52%", padding: "16px 24px 20px", overflowY: "auto" }}>
                        <a
                            className="clickLink"
                            onClick={() => profileId && window.open(`${BASE_URL}profile/${profileId}`, "_blank")}
                            style={{
                                fontSize: 30,
                                fontFamily: "Raleway",
                                fontWeight: "bold",
                                textDecoration: profileId ? "underline" : "none",
                                color: "black",
                                cursor: profileId ? "pointer" : "default",
                                display: "block",
                                marginBottom: 4,
                                lineHeight: 1.2,
                            }}
                        >
                            {displayName}
                        </a>

                        {actGenreString && actGenreString.length > 0 && (
                            <div className="genreContainer" style={{ marginLeft: -5, marginBottom: 10 }}>
                                {actGenreString.map((g, i) => (
                                    <span key={i} className="genreWrapper" style={{ backgroundColor: tableWidgetBgColor, color: tableFtColor }}>
                                        {g.name}
                                    </span>
                                ))}
                            </div>
                        )}

                        <div style={{ fontSize: "15px", fontFamily: "Open Sans", color: "rgba(0,0,0,0.75)", lineHeight: 1.55 }}>
                            <span dangerouslySetInnerHTML={{ __html: bioExpanded ? fullBio : shortBio }} />
                            {isTruncated && (
                                <span
                                    onClick={() => this.setState({ bioExpanded: !bioExpanded })}
                                    style={{ display: "inline-block", marginTop: 6, fontSize: 13, color: tableWidgetBgColor, cursor: "pointer", fontWeight: 600 }}
                                >
                                    {bioExpanded ? " Show less" : " Read more"}
                                </span>
                            )}
                        </div>

                        {(data?.bookTableUrl || data?.ticketUrl) && (
                            <div style={{ marginTop: 24, display: "flex", flexWrap: "wrap", gap: 10 }}>
                                {data?.bookTableUrl && (
                                    <button
                                        className="buttonStyle"
                                        style={{ backgroundColor: tableWidgetBgColor, color: tableFtColor, border: "none", borderRadius: 6, padding: "10px 22px", fontSize: 14, fontFamily: "Raleway", cursor: "pointer" }}
                                        onClick={() => window.open(bookingUrl, "_blank")}
                                    >
                                        Book A Table
                                    </button>
                                )}
                                {data?.ticketUrl && (
                                    <button
                                        className="buttonStyle"
                                        style={{ backgroundColor: tableWidgetBgColor, color: tableFtColor, border: "none", borderRadius: 6, padding: "10px 22px", fontSize: 14, fontFamily: "Raleway", cursor: "pointer" }}
                                        onClick={() => window.open(ticketUrl, "_blank")}
                                    >
                                        Buy Tickets
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );

        return ReactDOM.createPortal(modal, portalTarget);
    }
}

export default EmbedGigGridDetails;